import React from 'react';
import DbManagerResultsTab from '../DbManagerResultsTab';
import DbOverviewTab from './DbOverviewTab';
import { useTabsStore, selectCurrentDbManagerTab } from '../../store/tabsStore';
import { isDbOverviewTab } from '../../store/dbOverviewTabs';

/**
 * Which body a DB Manager tab gets: the database overview, or the results
 * grid / query editor every other DB tab is. Both are `db-manager-table` tabs
 * in the one strip; only the overview carries `view: 'overview'`.
 */
export default function DbManagerTabView() {
  const tab = useTabsStore(selectCurrentDbManagerTab);
  if (isDbOverviewTab(tab)) return <DbOverviewTab key={tab.id} tab={tab} />;
  return <DbManagerResultsTab />;
}
